<template>
  <div class="type-permanent">
    <WTooltip label="Essa categoria não pode ser alterada" position="bottom">
      <div class="type-permanent__content">
        <HTag size="large" color="magenta" class="type-permanent__tag">
          {{ label }}
        </HTag>
        <div v-if="date" class="type-permanent__description">
          {{ description }}
        </div>
      </div>
    </WTooltip>
  </div>
</template>
<script>
import { WTooltip } from '@alice-health/wonderland-vue'

import HTag from '@/components/shared/atoms/HTag.vue'
import { formatDateTime } from '@/utils/date'

export default {
  components: { HTag, WTooltip },
  props: {
    label: {
      type: String,
      required: true
    },
    date: {
      type: Date,
      default: undefined
    }
  },
  computed: {
    description() {
      return `Canal criado em ${this.dateFormatter}`
    },
    dateFormatter() {
      if (!this.date) {
        return ''
      }
      return formatDateTime(this.date)
    }
  }
}
</script>
<style scoped lang="scss">
.type-permanent {
  background: var(--gl-color-shades-white);
  border: var(--gl-border-width-xs) solid var(--gl-color-shades-gray-20);
  border-radius: var(--gl-border-radius-sm);
  padding: 10px var(--gl-spacing-02);
  width: 100%;
  &__tag {
    text-transform: none;
  }
  &__content {
    display: flex;
    gap: var(--gl-spacing-04);
    align-items: center;
    width: 100%;
    line-height: 20px;
  }
  &__description {
    font-weight: var(--gl-font-weight-regular);
    font-size: var(--gl-font-size-xxs);
    color: var(--gl-color-shades-gray-100);
  }
}
</style>
